import 'slick-carousel/slick/slick.min';

export default class Faq {

    constructor() {
        Faq.blocFaq();
    }

    static blocFaq() {

        function highlight() {
            let windowsTop = $(this).scrollTop();
            $(".highlight").each(function () {
                let objTop = $(this).offset().top;

                if (objTop < (windowsTop + $(window).height() - 300)) {
                    $(this).css("transform", "scale(1)");
                    $(this).css("filter", "grayscale(100%)");
                } else {
                    $(this).css("transform", "scale(0.9)");
                    $(this).css("filter", "grayscale(0%)");
                    $('.faq-bubus-icone', this).attr('src', $('.faq-bubus-icone').attr("src"));
                }
            });
        }

        highlight();
        $(window).scroll(function () {
            highlight();
        });


        //   FAQ  ---------------------------------------------------
        //-----------------------------------------------------------

        "use strict";

        // Insensibilité à la casse
        // ---------------------------------------------
        $.expr[":"].contains = $.expr.createPseudo(function (text) {
            return function (elem) {
                return $(elem).text().toLowerCase().indexOf(text.toLowerCase()) >= 0;
            };
        });

        // Insensibilité à l'accentuation
        // ---------------------------------------------
        $.expr[':'].contains = function (a, i, m) {
            let rExps = [
                {
                    re: /[\xC0-\xC6]/g,
                    ch: "A"
                },
                {
                    re: /[\xE0-\xE6]/g,
                    ch: "a"
                },
                {
                    re: /[\xC8-\xCB]/g,
                    ch: "E"
                },
                {
                    re: /[\xE8-\xEB]/g,
                    ch: "e"
                },
                {
                    re: /[\xCC-\xCF]/g,
                    ch: "I"
                },
                {
                    re: /[\xEC-\xEF]/g,
                    ch: "i"
                },
                {
                    re: /[\xD2-\xD6]/g,
                    ch: "O"
                },
                {
                    re: /[\xF2-\xF6]/g,
                    ch: "o"
                },
                {
                    re: /[\xD9-\xDC]/g,
                    ch: "U"
                },
                {
                    re: /[\xF9-\xFC]/g,
                    ch: "u"
                },
                {
                    re: /[\xC7-\xE7]/g,
                    ch: "c"
                },
                {
                    re: /[\xD1]/g,
                    ch: "N"
                },
                {
                    re: /[\xF1]/g,
                    ch: "n"
                }
            ];

            let element = $(a).text();
            let search = m[3];

            $.each(rExps, function () {
                element = element.replace(this.re, this.ch);
                search = search.replace(this.re, this.ch);
            });

            return element.toUpperCase()
                .indexOf(search.toUpperCase()) >= 0;
        };

        // ---------------------------------------------
        // Autocomplete suggestions
        // ---------------------------------------------

        $('#faq-search').keyup(function (e) {
            // Validation de la recherche par la touche entrée
            if (e.keyCode === 13) {
                $('#faq-submit').trigger('click');
            }
            const inputContent = $.trim($(this).val());
            if (!inputContent || inputContent.length < 3) {
                $('.form-faq-autocomplete, form-faq-autocomplete li').hide();
            } else {
                $('.form-faq-autocomplete, .form-faq-autocomplete li').show().not(':contains(' + inputContent + ')').hide();
            }
        });

        // ---------------------------------------------
        // Recherche à partir d'une prédiction
        // ---------------------------------------------

        $('.form-faq-autocomplete li').click(function () {
            const id = $(this).attr('id').split('-')[2];

            // reset
            $( '[data-faq-autocomplete-item]' ).hide();
            $( '#faq-search' ).val('');
            $('[data-faqcat]').addClass('unactive');

            $( '#faq-item-' + id ).addClass('active').removeClass('unactive');
        });

        // ---------------------------------------------
        // recherche en fonction d'une selection par tag
        // ---------------------------------------------
        $('.faq-list-tag li').click(function () {
            const category = $(this).attr('data-name');

            $('.faq-list-tag li').removeClass('active');
            $(this).addClass('active');

            // desaffiche tout
            $('[data-faqcat]').addClass('unactive');

            // affiche les concernés
            if ($('[data-faqcat]').length > 0) {
                $.each($('[data-faqcat]'), function (index, item) {
                    if ($(item).attr('data-faqcat') === category) {
                        $(item).addClass('active');
                        $(item).removeClass('unactive');
                    }
                });
            } else {
                $('#faq-bad-request').show(0);
            }
        });

        // ---------------------------------------------
        // recherche en fonction de l'entrée utilisateur
        // ---------------------------------------------
        $('#faq-submit').click(function () {
            let searchRequest = $('#faq-search').val();
            let result = $("p:contains(" + searchRequest + ")").length;

            if (result > 0) {
                if (searchRequest != "" && ($.trim($("#faq-search").val()).length >= 3)) {
                    $('#faq-home-img').hide(0);
                    $("p:contains(" + searchRequest + ")").each(function () {
                        $($(this).parent()).addClass('active');
                    });
                } else {
                    $('#faq-home-img').show(0);
                }
            } else {
                $('#faq-bad-request').show(0);
                $('#faq-home-img').hide(0);
            }
            $('#faq-search').val('');
        });


        //   Premiers pas Tutoriel ----------------------------------
        //-----------------------------------------------------------
        $('.slider-title').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            arrows: false,
            draggable: false,
            swipe: false,
            swipeToSlide: false,
            touchMove: false,
            centerMode: true,
            asNavFor: '.slider-content',
            adaptiveHeight: false
        });

        $('.slider-content').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            arrows: false,
            draggable: false,
            swipe: false,
            swipeToSlide: false,
            touchMove: false,
            centerMode: true,
            asNavFor: '.slider-title',
            adaptiveHeight: false
        });

        $('div[data-slide]').click(function (e) {
            e.preventDefault();
            let slideno = $(this).data('slide');
            $('.slider-title,.slider-content').slick('slickGoTo', slideno - 1);
        });

        $(".premiers-pas-section-item").click(function (e) {

            if (window.matchMedia("(max-width: 700px)").matches) {
                $('#premiers-pas-menu-principal').animate({top: "-5000px"}, 1000, function () {
                    // taille du conteneur adaptée au slider
                    $('.main-premiers-pas').css("height", "auto");
                    $(this).css("display", "none");
                    highlight();
                });
            } else {
                $('#premiers-pas-menu-principal').animate({top: "-2000px"}, 1000, function () {
                    // taille du conteneur adaptée au slider
                    $('.main-premiers-pas').css("height", "auto");
                    $(this).css("display", "none");
                    highlight();
                });
            }

            // positionnnement en haut de page
            $('html, body').animate({scrollTop: 0}, "slow");
            // defilement du slider au chapitre choisis
            let slidenum = $(this).data('slide');

            $('.slider-title, .slider-content').css("display", "none");
            $('.slider-title, .slider-content').slick('slickGoTo', slidenum - 1).css("display", "block");


            // cache le menu et fait apparaitre le slider
            $('#premiers-pas-detail').css("visibility", "visible");
            $('#premiers-pas-detail').css("display", "block");

            if (window.matchMedia("(max-width: 700px)").matches) {
                $('.page-template-template-premiers-pas footer').css('padding-left', '60px');
            }
        });

        $('.action').click(function () {
            $('.action').removeClass('nav-icon-active');
            $(this).addClass('nav-icon-active');
        });
        $(".slider").on("afterChange", function () {
            let idSlide = +$(".slick-active").attr('data-slick-index') + 1;
            $('.action').removeClass('nav-icon-active');
            $('#nav-icon-' + idSlide).addClass('nav-icon-active');
        });
    }

}